import { useForm } from "../../hooks/useForm"
import WithSidebar from "../../layouts/WithSidebar"
import Input from '../../blocks/Input'
import './change.css'
import { useNavigate } from 'react-router-dom';
import { ajax } from "../../scripts/helper";
import utils from "../../scripts/utils";
import { useSnackbar } from "notistack";



const ChangePassword = () => {
    const navigate = useNavigate();
    const {enqueueSnackbar} = useSnackbar()
    const [inputFields, handleChange, setInputFields] = useForm({
        currentPassword: {
            name: "currentPassword",
            value: '',
            type: "password",
            placeholder: '*****'
        },
        newPassword: {
            name: 'newPassword',
            value: '',
            type: 'password',
            placeholder: '*****'
        }
    })

    const saveButton = async() => {
        const res = await ajax({
            method: 'PUT',
            url: utils.urls.changePassword,
            hasToken: true,
            snackbar: enqueueSnackbar,
            data: {
                "currentPassword": inputFields.currentPassword.value,
                "newPassword": inputFields.newPassword.value
            }
        })

        if(!res) return

        navigate(-1)
    }


    return (
        <WithSidebar breadcrumb={"User > Change Password"} pageTitle={"Change Password"}>
            <></>
            <div className="chpass-form-container__inputs">
                <div className="row">
                    <div className="officeId">
                        <label>Current password</label>
                        <Input
                        className="extra"
                        inputField={inputFields.currentPassword}
                        onChange={handleChange}
                        />
                    </div>
                    <div className="officeCode">
                        <label>New password</label>
                        <Input
                        className="extra"
                        inputField={inputFields.newPassword}
                        onChange={handleChange}
                        />
                    </div>
                </div>
            </div>
            <div className="pass-edit-btn">
                <button className="delete" onClick={() => navigate(-1)}>Back</button>
                <button className="save" onClick={() => saveButton()}>Change Password</button>
            </div>


        </WithSidebar>
    )

}

export default ChangePassword